export default __webpack_public_path__ + "static/media/rightClickMenu.5c63ae77.gif";